import {Timezone} from "../../Models/Timezone";
const TIMEZONES: Timezone[] = [

  new Timezone().fill({
    abbreviation: "BIT",
    name: "Baker Island Time",
    offset: "UTC-12"
  }),
  new Timezone().fill({
    abbreviation: "SST",
    name: "Samoa Standard Time",
    offset: "UTC-11"
  }),
  new Timezone().fill({
    abbreviation: "CKT",
    name: "Cook Island Time",
    offset: "UTC-10"
  }),
  new Timezone().fill({
    abbreviation: "AKST",
    name: "Alaska Standard Time",
    offset: "UTC-09"
  }),
  new Timezone().fill({
    abbreviation: "PST",
    name: "Pacific Standard Time",
    offset: "UTC-08"
  }),
  new Timezone().fill({
    abbreviation: "MST",
    name: "Mountain Standard Time",
    offset: "UTC-07"
  }),
  new Timezone().fill({
    abbreviation: "CST",
    name: "Central Standard Time",
    offset: "UTC-06"
  }),
  new Timezone().fill({
    abbreviation: "EST",
    name: "Eastern Standard Time",
    offset: "UTC-05"
  }),
  new Timezone().fill({
    abbreviation: "AST",
    name: "Atlantic Standard Time",
    offset: "UTC-04"
  }),
  new Timezone().fill({
    abbreviation: "UYT",
    name: "Uruguay Standard Time",
    offset: "UTC-03"
  }),
  new Timezone().fill({
    abbreviation: "GST",
    name: "South Georgia and South Sandwich Islands",
    offset: "UTC-02"
  }),
  new Timezone().fill({
    abbreviation: "EGT",
    name: "Eastern Greenland Time",
    offset: "UTC-01"
  }),
  new Timezone().fill({
    abbreviation: "GMT",
    name: "Greenwich Mean Time",
    offset: "UTC+00"
  }),
  new Timezone().fill({
    abbreviation: "UTC",
    name: "Coordinated Universal Time",
    offset: "UTC+00"
  }),
  new Timezone().fill({
    abbreviation: "CET",
    name: "Central European Time",
    offset: "UTC+01"
  }),
  new Timezone().fill({
    abbreviation: "EET",
    name: "Eastern European Time",
    offset: "UTC+02"
  }),
  new Timezone().fill({
    abbreviation: "FET",
    name: "Further-eastern European Time",
    offset: "UTC+03"
  }),
  new Timezone().fill({
    abbreviation: "GST",
    name: "Gulf Standard Time",
    offset: "UTC+04"
  }),
  new Timezone().fill({
    abbreviation: "TFT",
    name: "Indian/Kerguelen",
    offset: "UTC+05"
  }),
  new Timezone().fill({
    abbreviation: "BST",
    name: "Bangladesh Standard Time",
    offset: "UTC+06"
  }),
  new Timezone().fill({
    abbreviation: "THA",
    name: "Thailand Standard Time",
    offset: "UTC+07"
  }),
  new Timezone().fill({
    abbreviation: "SST",
    name: "Singapore Standard Time",
    offset: "UTC+08"
  }),
  new Timezone().fill({
    abbreviation: "KST",
    name: "Korea Standard Time",
    offset: "UTC+09"
  }),
  new Timezone().fill({
    abbreviation: "AEST",
    name: "Australian Eastern Standard Time",
    offset: "UTC+10"
  }),
  new Timezone().fill({
    abbreviation: "NFT",
    name: "Norfolk Time",
    offset: "UTC+11"
  }),
  new Timezone().fill({
    abbreviation: "NZST",
    name: "New Zealand Standard Time",
    offset: "UTC+12"
  })
];

export default TIMEZONES;







// WEBPACK FOOTER //
// /app/src/app/Components/time-selector/timezones.ts